import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';
import { GameLogic } from '../../Logic/GameLogic';
import { GameModel, GameStateEnum } from '../../Models/GameModel';
import { filters, Graphics } from 'pixi.js';
import gsap from 'gsap';

export enum BackgroundNames {
    first = 'first',
    winter = 'winter',
}

export class IBackgroundContainerOptions {
    name?: BackgroundNames.first | BackgroundNames.winter;
}

export class BackgroundContainer extends AnimationBaseController {
    $model: GameModel;

    private blur: filters.BlurFilter;

    private overlay: Graphics;
    private overlayShowingTime: number = 0.15;

    constructor(
        @Inject private options: IBackgroundContainerOptions,
        @Inject private gameLogic: GameLogic,
    ) {
        super('BackgroundContainer');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        this.blur = new filters.BlurFilter(2, 1, 1, null);
        this.blur.passes = 2;

        this.overlay = new Graphics();
        this.overlay.alpha = 0;

        return {
            animationContent: AnimationContents.BACKGROUNDS_JSON,
            libraryName: 'background',
            modelWatch: {
                gameState: async (state: GameStateEnum) => {
                    switch (state) {
                        case GameStateEnum.catalog: {
                            this.showOverlay();
                            break;
                        }

                        case GameStateEnum.album:
                            this.showBlur();
                            break;

                        default:
                            this.hideOverlay();
                            this.hideBlur();
                    }
                },
            },
        };
    }

    protected onInitialize(): void {
        this.parentContainer.addChild(this.overlay);
        // TODO картинки бэка и ПРЕЛОДЕРА должны быть одинаковы!
        // this.gotoAndStop(this._options.name || BackgroundNames.first);
        //this.gotoAndStop(BackgroundNames.first);
        this.gotoAndStop(BackgroundNames.first);
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.scaleX = this.scaleY = Math.max(width / scale / 1920, height / scale / 1440);
        this.resizeOverlay(width, height, scale);
    }

    private showBlur(): void {
        this.display.filters = [this.blur];
    }

    private hideBlur(): void {
        this.display.filters = [];
    }

    private showOverlay(): void {
        gsap.killTweensOf(this.overlay);
        gsap.to(this.overlay, this.overlayShowingTime, { alpha: 1 });
    }

    private hideOverlay(): void {
        gsap.killTweensOf(this.overlay);
        gsap.to(this.overlay, this.overlayShowingTime, { alpha: 0 });
    }

    private resizeOverlay(width: number, height: number, scale: number): void {
        if (this.overlay) {
            this.overlay.clear();
            this.overlay.beginFill(0x000000, 0.75);
            this.overlay.drawRect(-width / 2 / scale, -height / 2 / scale, width / scale, height / scale);
            this.overlay.endFill();
        }
    }
}
